const routes = [
    {
        name: 'contaBancariaParceiro',
        path: '/parceiro/financeiro/conta_bancaria',
        alias: ['/parceiro/financeiro/conta_bancaria/index', '/contabilidade/financeiro/conta_bancaria', '/contabilidade/financeiro/conta_bancaria/index'],
        component: () => import('../views/ContaBancaria')
    },
    {
        name: 'atualizarContaBancariaParceiro',
        path: '/parceiro/financeiro/atualizar_conta_bancaria',
        alias: ['/contabilidade/financeiro/atualizar_conta_bancaria'],
        component: () => import('../views/Atualizar')
    },
    {
        name: 'vizualizarContaBancariaParceiro',
        path: '/parceiro/financeiro/visualizar_conta_bancaria',
        alias: ['/contabilidade/financeiro/visualizar_conta_bancaria'],
        component: () => import('../views/Visualizar')
    },
    {
        name: 'vizualizarContaBancariaIdParceiro',
        path: '/parceiro/financeiro/visualizar_conta_bancaria/:id',
        alias: ['/contabilidade/financeiro/visualizar_conta_bancaria/:id'],
        component: () => import('../views/Visualizar')
    }
]

export default routes
